import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="bottom-nav global-footer">
    <ul>
      <li><Link to="/contact">Contact</Link></li>
      <li><Link to="/terms">Terms of Service</Link></li>
      <li><Link to="/privacy">Privacy Policy</Link></li>
    </ul>
    <div className="footer-copyright">
      &copy; {new Date().getFullYear()} PlayMaker Pics. All rights reserved.
    </div>
  </footer>
);

export default Footer; 